import { formatPics, filterParams } from '@/common/utils/format'
import { i18n, getBDCountry, sprintf } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'

import { get } from 'lodash-es'

export function revert (data = {}) {
  const land = get(data, 'bizGlobal.docInfo.land')
  if (!land) return {}
  return {
    licensePics: formatPics(land.licensePics),
    files: formatPics(land.files)
  }
}

export function submitFormat (landInfo) {
  return {
    params: JSON.stringify({
      source: 'contractor',
      queryId: this.$route.params.id,
      bizGlobal: {
        ...landInfo.bizGlobal,
        country: country
      }
    })
  }
}

export default {
  revert,
  submitFormat
}
